export default "__VITE_ASSET__WjoVhYIC__"